import {
  Channel,
  Choice,
  KeyValuePair
} from "@directv-digital/dds.services.channel-lineup-provider";
import { ChannelFilter } from "./chlupStore";

export function filterChannelsList(
  channels: Channel[],
  filter: ChannelFilter
) {
  if (channels?.length === 0) {
    return channels;
  }

  const filtered = [];
  for (const channel of channels) {
    if (filter?.searchList &&
        !filter?.searchList.some((ch: Choice) => channel?.name?.toLowerCase()?.includes(ch?.name?.toString()))) {
      continue;
    }
    if (filter?.categories &&
        !filter?.categories?.some((ctg: string) => ctg === channel?.category)) {
      continue;
    }
    if (filter?.chnlPackages?.length > 0 &&
        !filter?.chnlPackages?.some((pkg: string) => channel?.chnlPackages?.includes(pkg))) {
      continue;
    }
    if (filter?.addOnPromoAny && channel?.isAddOnPromoAny !== filter?.addOnPromoAny) {
      continue;
    }
    if (filter?.local && ((channel?.category === "LOCAL") !== filter?.local)) {
      continue;
    }
    if (filter?.rsn && (channel?.category === "RSN") !== filter?.rsn) {
      continue;
    }
    if (filter?.myFreeDtv &&
        channel?.isMyFreeDTV !== filter?.myFreeDtv) {
      continue;
    }
    filtered.push(channel);
  }

  return filtered;
};

export function queryChannels(filter: ChannelFilter, channels?: Channel[]) {
  const filtered = [];
  for (const channel of channels) {
    if (filter?.product &&
      ((channel?.isStream && filter?.product === 'satellite') || (channel?.isSatellite && filter?.product === 'stream'))) {
      continue;
    }
    if (filter?.searchList &&
        !filter?.searchList.some((ch: Choice) => channel?.name?.includes(ch?.value?.toString()))) {
      continue;
    }
    if (filter?.categories &&
        !filter?.categories?.some((ctg: string) => ctg === channel?.category)) {
      continue;
    }
    if (filter?.chnlPackages?.length > 0 &&
        !filter?.chnlPackages?.some((pkg: string) => channel?.chnlPackages?.includes(pkg))) {
      continue;
    }
    if (filter?.addOnPromoAny &&
      channel?.isAddOnPromoAny !== filter?.addOnPromoAny) {
      continue;
    }
    if (filter?.includedAny &&
      channel?.isInclAny !== filter?.includedAny) {
      continue;
    }
    if (filter?.local &&
      ((channel?.category === "LOCAL") !== filter?.local)) {
      continue;
    }
    if (filter?.rsn &&
      (channel?.category === "RSN") !== filter?.rsn) {
      continue;
    }
    if (filter?.myFreeDtv &&
        channel?.isMyFreeDTV !== filter?.myFreeDtv) {
      continue;
    }
    filtered.push(channel);
  }

  // console.log(`STORE == filtered channel block from ${channels.length} to ${filtered.length} channels`);
  return filtered;
};

export function filterCategoricalChannels(
  filter: ChannelFilter, channels: any
) {
  const filteredChannels = {};

  // eslint-disable-next-line guard-for-in
  for (const key in channels) {
    const data = channels[key];

    if (Array.isArray(data)) {
      const filteredCtgy = queryChannels(filter, data);
      if (filteredCtgy?.length > 0) {
        filteredChannels[key] = filteredCtgy;
      }
    } else {
      const filteredSubcategory = filterCategoricalChannels(filter, data);
      if (Object.keys(filteredSubcategory).length > 0) {
        filteredChannels[key] = filteredSubcategory;
      }
    }
  }
  return filteredChannels;
};

export const orderCategoriesSubarray = (refCategories: KeyValuePair[], unsorted: KeyValuePair[]) => {
  const addOnCtg = unsorted?.filter(ctg => ctg?.key === "ADD_ON_CHANNELS") || [] as KeyValuePair[];

  // assuming that refCategories (from server) is pre-sorted properly
  const sorted = [];
  for (const ctg of refCategories) {
    if (ctg?.key === "ADD_ON_CHANNELS") {
      continue;
    }
    const isInCategory = unsorted.some(category => category.key === ctg.key);
    if (isInCategory) {
      sorted.push(ctg);
    }
  }

  // console.log("filtered categories", sorted);
  return [...sorted, ...addOnCtg];
}

export const orderCategoriesExact = (categories: KeyValuePair[], sortKeyArray: string[]) => {
  const sorted = [];
  const ctgKeys = categories?.map(ctg => ctg?.key);

  // eslint-disable-next-line no-plusplus
  for (let srtIx = 0; srtIx < sortKeyArray.length; srtIx++) {
    if (ctgKeys.includes(sortKeyArray[srtIx])) { //
      const kvMatch = categories.find(ctg => ctg?.key === sortKeyArray[srtIx]);
      sorted.push(kvMatch);
    }
  }
  return sorted.length > 0 ? sorted : categories;
};

